import { ScoutHost } from "generated-graphql/graphql";

/**
 * Maps the GraphQL `ScoutHost` enum to the runtime host string used across
 * Scout PostHog events (`full_page` / `popover`), so client-emitted Scout
 * events line up with the server-emitted turn/tool events on the same property.
 */
export function scoutHostToRuntime(host: ScoutHost): string {
  return host === ScoutHost.Popover ? "popover" : "full_page";
}
